import { Type } from '@angular/core';
import { Routes } from '@angular/router';
import { RenderMode, ServerRoute } from '@angular/ssr';
import { ToolbarDevComponent } from '@shared/components/toolbar-dev/toolbar-dev.component';

// Developer tools: the dev toolbar with its tenant switcher, and the design-system pages. Kept out
// of the production bundle, not just hidden (#906): the production configuration in angular.json
// swaps this file for dev-tools.prod.ts, as it swaps environment.ts for environment.prod.ts.

export const DEV_TOOLBAR: Type<unknown> | null = ToolbarDevComponent;

export const DEV_ROUTES: Routes = [
  {
    path: 'design-system',
    loadChildren: () =>
      import('@features/design-system/design-system.routes').then((m) => m.designSystemRoutes),
  },
];

export const DEV_SERVER_ROUTES: ServerRoute[] = [
  {
    // No need to prerender a dev tool, and components/:slug has dynamic params with no
    // getPrerenderParams defined.
    path: 'design-system/**',
    renderMode: RenderMode.Client,
  },
];
